import { Engine } from '../../core/engine/Engine.type'
import onWindowEvent from '../../onWindowEvent'
import { getEngineKeyDownReactiveMap } from '../../three/fn/getSetEngineKeyDownReactiveMap'

export default function registerKeyUpEvent(engine: Engine) {
  const keyDownReactiveMap = getEngineKeyDownReactiveMap(engine)
  function onKeyUp(event: KeyboardEvent) {
    // console.log('onKeyUp', event)
    keyDownReactiveMap.delete(event.key)
  }

  onWindowEvent('keyup', onKeyUp)
}
